import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

import SmartFeedShowSelection from "%/dynamic-component-editor/options/smart-feed-show-selection";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useGeneralStore = (...args) => require("%/dynamic-component-editor/stores/general-store").useGeneralStore(...args);


export default class SmartFeedSeasonSelection extends BaseOption {
  static label = "Season";

  static userInterfaceComponent = (optionValues = {}) => {
    const safeOptionValues = optionValues || {};
    const showSelection = new SmartFeedShowSelection().getValueFromConfiguration(safeOptionValues);
    const showId = typeof showSelection === "object" && showSelection !== null
      ? showSelection.value
      : showSelection;
    const hasShowSelection = Boolean(showId);

    return {
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        isAsync: true,
        showAllResultsOnClick: true,
        sourceUrl: () => {
          if (!hasShowSelection) {
            return "";
          }

          return `${useGeneralStore().apiV1}/shows/${showId}/seasons/autocomplete`;
        },
        itemValueKey: "value",
        itemLabelKey: "label",
        placeholder: "Search seasons...",
        runInitialSearch: true,
        includeValueType: "number",
        disabled: !hasShowSelection,
      },
    };
  };

  static defaultValue = "";
}
